import { render } from "./TrackingDetails.vue?vue&type=template&id=5ee9f124&scoped=true"
import script from "./TrackingDetails.vue?vue&type=script&lang=js"
export * from "./TrackingDetails.vue?vue&type=script&lang=js"

import "./TrackingDetails.vue?vue&type=style&index=0&id=5ee9f124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee9f124"]])

export default __exports__